import { EDatePickerMode } from '../../../types'
import { IDatePickerModeLang } from '../../../types/lang'

export const datePickerModeLang: IDatePickerModeLang = {
	date_picker_mode: {
		[EDatePickerMode.today]: 'today_ua',
		[EDatePickerMode.yesterday]: 'yesterday_ua',
		[EDatePickerMode.currentWeek]: 'current week_ua',
		[EDatePickerMode.last7Days]: 'last 7 days_ua',
		[EDatePickerMode.currentMonth]: 'current month_ua',
		[EDatePickerMode.lastMonth]: 'last month_ua',
		[EDatePickerMode.last30Days]: 'last 30 days_ua',
		[EDatePickerMode.currentYear]: 'current year_ua',
		[EDatePickerMode.pastYear]: 'past year_ua'
	}
}